import React from 'react';

import PDF from "./PDFComponent";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as tableActions from '../../../store/actions/table';
import PublicPDF from "./PublicPDFComponent";

const PDFPage = (props) => {

    const roundNumber = 2; // actually 3
    const judgeNumber = props.match.params.judge ? parseInt(props.match.params.judge) - 1 : 0;

    const events = props.events;
    if (!events) return null;
    const event = events.event;
    const round = events.competition.template.rounds[roundNumber + 1];
    var scores = round.scores[judgeNumber];
    scores = scores.filter(item => item.wq);

    let grade = events.competition.competition.grade;
    let comp = events.competition.competition;

    let ageTitle = '';

    for(var col of grade.columns){
        if (col.id.toString() === comp.column) {
            ageTitle = col.title;
        }
    }

    const competitionName = events.competition.competition.grade.title + " " +
        events.competition.competition.rowTitle + " | " +
        ageTitle;
    const code = events.competition.competition.code;

    const titles = [
        event.name,
        code,
        competitionName
    ]

    const headers = [
        "Rank",
        "Dancer #",
        "Name",
        "School",
    ]

    scores = scores.sort((a, b) => {
        return a["finalRank"] - b["finalRank"]
    })

    let chunks = [];
    var i,j, temporary, chunk3 = 20;
    for (i = 0,j = scores.length; i < j; i += chunk3) {
        temporary = scores.slice(i, i + chunk3);
        chunks.push(temporary);
        // do whatever
    }

    //console.log("tem", chunks, scores);


    let tables = [];

    for(var chunk of chunks) {
        var content = chunk.map((score, i) => {
            let rel = events.competition.entries.filter(item => item._id === score.entryCompetition);
            //console.log("Rel", rel, events.competition.entries[i]);
            let s = {};

            if (rel.length > 0) {
                s = rel[0];
            }
            return [
                score["finalRank"],
                s.dancerNumber ? s.dancerNumber : 0,
                s.dancer ? s.dancer.name + " " + s.dancer.lname : "",
                s.dancer ? s.dancer.school.name : "",

            ]
        });

        tables.push({
            headers,
            content
        });
    }





    const table = {
        headers,
        content
    }


    const pdfData = {
        table,
        titles,
        tables,
        image: props.events.competition.competition.grade.event.image.path,
    }

    return (
        <div style={{ height: "100vh" }}>

            <PublicPDF pdfData={pdfData} />
        </div>
    );
}

const mapStateToProps = state => ({
    auth: state.auth,
    table: state.table,
    user: state.user,
    events: state.events
});


const mapDispatchToProps = dispatch => ({
    getTableData: (view, skip, limit, sort, token, mode) => {
        dispatch(tableActions.getTableDataWithQuery(view, skip, limit, sort, {}, token, mode));
    },
    getTableDataWithQuery: (view, skip, limit, sort, query, token, mode) => {
        dispatch(tableActions.getTableDataWithQuery(view, skip, limit, sort, query, token, mode));
    },
});


const Connected = withRouter(connect(mapStateToProps, mapDispatchToProps)(PDFPage));

class PDFPageContainer extends React.Component {
    render() {
        return (
            <div>
                <Connected {...this.props} />
            </div>
        )
    }
}

export default PDFPageContainer;
